import React from 'react'
import "./Spinner.css";

const Spinner = () => {
  return (
    <div className='justify-center items-center flex mt-[210px]'>
      <div className='spinner'></div>
    </div>

  )
}

export default Spinner;